import { BookingProvider, DateInMilliSec } from "@common/constans";
import { IOriginDestinationRequest, IRoute } from "@common/models";
import { IWeekSchedule } from "@common/models/CMS";
import { createUrlSearchParams, fetchAvailabilityRequest, initAvailabilityRequest } from "@components/flightSearch/FlightSearch";
import { Culture } from "@core/index";
import { IAppState } from "@misc/State";
import Config from "@service/Config";
import { FC } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

interface IWeeklyFlightAvailabilityProps {
    route: IRoute;
    destinationVisiblity?: boolean;
    weekDaysTitleVisiblity?: boolean;
    onDayAvailabilityClick?: (departureDate: number) => void;
}

const WeeklyFlightAvailability: FC<IWeeklyFlightAvailabilityProps> = ({ route, destinationVisiblity = true, weekDaysTitleVisiblity = true, onDayAvailabilityClick }) => {
    const locale = Culture.getLocale();
    const { push } = useHistory();
    const { availabilityRequest } = useSelector((state: IAppState) => ({ availabilityRequest: state.availabilityRequest }));

    const onDayClick = (day: string) => {
        // Create origin destination for availability request
        const selectedWeekDay: number = locale.weekDays.findIndex(x => x.day.toLowerCase() === day.toLowerCase());
        const currentDate = Culture.getDateTimeInstance();
        let addedDay: number = 0;
        if (selectedWeekDay >= currentDate.getDay())
            addedDay = selectedWeekDay - currentDate.getDay()
        else
            addedDay = 7 - (currentDate?.getDay() - selectedWeekDay);
        const originDestinationRequest: IOriginDestinationRequest = {
            originCode: route.origin,
            destinationCode: route.destination,
            departureDate: currentDate.setTime(currentDate.getTime() + (addedDay * DateInMilliSec.dayPerMilliSeconds)).getTime(),
        }
        // Asign origin destination to availability request
        availabilityRequest.originDestionations = [originDestinationRequest];
        if (onDayAvailabilityClick && originDestinationRequest.departureDate)
            onDayAvailabilityClick(originDestinationRequest.departureDate)
        else {
            initAvailabilityRequest(availabilityRequest);
            fetchAvailabilityRequest(availabilityRequest);
            if (Config.config.defaultBookingProvider === BookingProvider.Mahan)
                push(createUrlSearchParams(availabilityRequest));
        }
    }

    return (
        <div className="weekly-flight-availability flex column-direction">
            <div className="weekly-flight-availability-row row flex flex-grow spa-1">
                {
                    weekDaysTitleVisiblity && locale.weekDays.map((x, index) => <div key={index} className="weekly-flight-availability-columns flex justify-center col-1-7">{x.abbreviation}</div>)
                }
            </div>
            <div className="weekly-flight-availability-row row spa-1 flex flex-grow">
                {
                    locale.weekDays.map((x, index) => <div key={index} className="weekly-flight-availability-columns flex col-1-7 justify-center" onClick={() => onDayClick(x.day)}>
                        <div className={`flex flex-center justify-center${route.weekSchedule && route.weekSchedule[x.day.toLowerCase() as keyof IWeekSchedule] ? " circle" : ""}`}>
                            {(route.weekSchedule && route.weekSchedule[x.day.toLowerCase() as keyof IWeekSchedule]) || "-"}
                        </div>
                    </div>)
                }
            </div>
        </div>
    )
}

export default WeeklyFlightAvailability;